import { Menu } from '@base-ui/react/menu'
import { twMerge } from 'tailwind-merge'
import { listSeparator } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface MenuSeparatorProps extends PartProps<Menu.Separator.Props> {
  className?: string
}

function MenuSeparator({ className, ...props }: MenuSeparatorProps) {
  return <Menu.Separator className={twMerge(listSeparator, className)} {...props} />
}

export { MenuSeparator }
